/* === LBM REVEAL v2 -- animations au defilement, sans interception scroll === */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.IntersectionObserver) return;

  /* Selecteurs qui doivent apparaitre au scroll
     IMPORTANT : selecteurs tres specifiques pour ne pas attraper
     les menus, sidebars, navigations du theme */
  var FADE_UP = [
    '.banner__content .banner__heading',
    '.banner__content .banner__text',
    '.banner__content .banner__buttons',
    '.rich-text__wrapper',
    '.image-with-text__content',
    '.multicolumn-card__info',
    '.title-wrapper h2',
    '.title-wrapper .title',
    '.footer__column',
    '.main-page-content > p',
    '.main-page-content > h2',
    '.main-page-content > blockquote',
    '.lbm-ct__left',
    '.lbm-ct__right',
    '.lbm-ev__featured',
  ];

  var SCALE_IN = [
    '.banner__media',
    '.image-with-text__media-item',
  ];

  /* CSS injecte dynamiquement */
  var css = [
    '.lbm-rup { opacity: 0; transform: translateY(30px);',
    '  transition: opacity .85s cubic-bezier(.4,0,.2,1),',
    '              transform .85s cubic-bezier(.4,0,.2,1); }',
    '.lbm-rup.lbm-in { opacity: 1; transform: none; }',
    '.lbm-rsc { opacity: 0; transform: scale(1.05);',
    '  transition: opacity 1.1s cubic-bezier(.4,0,.2,1),',
    '              transform 1.1s cubic-bezier(.4,0,.2,1); }',
    '.lbm-rsc.lbm-in { opacity: 1; transform: none; }',
  ].join('\n');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* Eviter les elements deja visibles au chargement */
  function isInViewOnLoad(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.9;
  }

  function tagElements() {
    FADE_UP.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.lbmR) return;
        el.dataset.lbmR = '1';
        if (isInViewOnLoad(el)) {
          /* Deja visible : juste s'assurer qu'il reste visible */
          return;
        }
        el.classList.add('lbm-rup');
      });
    });

    SCALE_IN.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.lbmR) return;
        el.dataset.lbmR = '1';
        if (isInViewOnLoad(el)) return;
        el.classList.add('lbm-rsc');
      });
    });

    /* Cartes produits en grille uniquement (pas les sidebars) */
    var grids = document.querySelectorAll('.featured-collection .product-grid, .collection-grid');
    grids.forEach(function (grid) {
      grid.querySelectorAll('.card-wrapper').forEach(function (card, i) {
        if (card.dataset.lbmR) return;
        card.dataset.lbmR = '1';
        if (isInViewOnLoad(card)) return;
        card.classList.add('lbm-rup');
        card.style.transitionDelay = (i % 4) * 0.1 + 's';
      });
    });
  }

  function observe() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lbm-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -20px 0px' });

    document.querySelectorAll('.lbm-rup, .lbm-rsc').forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    tagElements();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    requestAnimationFrame(init);
  }

  /* Compatibilite sections Shopify rechargees dynamiquement */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () { tagElements(); observe(); }, 150);
  });

})();
